const styles = theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  coverImageThumb : theme.coverImageThumb
});

export default styles;